import React from 'react';

const ProfileContent = ({ information }) => {
  return (
    <div className="space-y-4">
      {information
        .filter((item) => item.id !== 1)
        .map((item) => (
          <div key={item.id} className="bg-gray-50 p-4 rounded-lg shadow-sm border-l-4 border-teal-500">
            <h3 className="text-md font-semibold text-gray-700 mb-3 flex items-center">
              <span className="w-2 h-2 bg-teal-500 rounded-full mr-2"></span>
              {item.title}
            </h3>
            <ul className="space-y-2 text-sm">
              {item.content.map((detail, index) => (
                <li key={index} className="text-gray-600 flex">
                  <strong className="min-w-0 flex-shrink-0 mr-2">{detail.label}:</strong>
                  <span className="flex-1">{detail.value}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
    </div>
  );
};

export default ProfileContent;